import * as types from "../types";

const initialState = {
    loading: false,
    accessToken: null, 
    product_id: null,
    resFetBidStatus: null,
    error: null
}

export default function fetchBidStatusReducer(state = initialState, action){
    
    switch(action.type){
        case types.FETCH_BID_STATUS_REQUEST :
            return{
                ...state,
                loading: true,
                accessToken: action.payload.accessToken,
                product_id:action.payload.product_id,
            }

        case types.FETCH_BID_STATUS_SUCCESS :
            return{
                ...state,
                loading: false,
                resFetBidStatus: action.payload.resFetBidStatus,
            }

        case types.FETCH_BID_STATUS_FAILURE :
            return{
                ...state,
                loading: false,
                accessToken: null,
                product_id:null,
                resFetBidStatus: null,
                error: action.payload.error
            }

        default :
        return state;

    }

}